import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const IncreaseLimitModal = ({ trigger, content, heading }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div onClick={handleShow}>{trigger}</div>

      <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="c0">
            <span className="c1">
              If you have a credit card and your account is in good standing,
              now is an excellent time to request an increase in your credit
              limit. Issuers became extremely risk-averse after the 2008
              financial crisis, reducing credit limits or canceling accounts
              outright. But now, these businesses are sending out more offers,
              and some are taking into consideration candidates with
              less-than-perfect credit as they feel more optimistic about the
              economy. We don&#39;t want to encourage anyone to take on
              additional debt, but if you properly utilize your credit, a
              greater credit limit may actually improve your credit score if you
              only use a small portion of it. Continue reading to learn what to
              say and what not to say to increase your credit.
            </span>
          </p>
          <p className="c0">
            <span className="c1">
              Please note: if you have really strong credit, you have a better
              chance of receiving an increase in credit limit. If your credit is
              damaged or subpar, your odds of increasing your credit limit is
              low. Either way, here are some suggestions on how to obtain
              additional credit if you have the applicable credit &nbsp;score:
            </span>
          </p>
          <p className="c0">
            <span className="c2 fw-bold">1. Justify your request for the limit increase</span>
            <span className="c1">
              . Contact customer service and tell the customer service agent
              that you want to start using your credit card more, such as
              utilizing the account to pay your smartphone bill each month.
              Convince them that you&#39;d like &nbsp;to use the card more, but
              you need to maintain your credit usage percentage under 30%.
              Another point you can bring up is the rewards you wish to take
              advantage of if your credit card has a rewards program.
              &quot;I&#39;d really like to take more advantage of your fantastic
              rewards program, but I&#39;m worried about my usage ratio being
              too high. Could you increase my limit?&rdquo;
            </span>
          </p>
          <p className="c0">
            <span className="c2 fw-bold">2. Be confident when presenting your point.</span>{" "}
            <span className="c1">
              Mention any rise in your credit score since you first applied for
              the card. If your financial situation has improved since opening
              the account, you should report that as well. Inform the issuer if
              you received a promotion, settlement, second employment, or other
              increase in your income. Moreover, let them know if you just paid
              off a significant obligation (such as a mortgage or college
              tuition). It shows the issuer that you now have more discretionary
              income. Feel free to also remind the issuer that you have been a
              user of their establishment for a specific period of time and
              remained loyal to them.
            </span>
          </p>
          <p className="c0">
            <span className="c2 fw-bold">3. Encourage competition from your issuer.</span>{" "}
            <span className="c1">
              You most likely receive direct mail solicitations frequently if
              you have a good credit score. Take advantage of those junk
              letters. Use the fact that creditors are aware of your easy
              ability to get an increase elsewhere. You should make it seem as
              if the current card issuer is not your main option and you have
              back up options lined up! &nbsp;Inform them that you are debating
              transferring a balance to another card, but that you would like to
              stay with them if they would only raise your credit limit.
            </span>
          </p>
          <p className="c0">
            <span className="c2 fw-bold">4. Don&#39;t tell anyone your sad tale.</span>
            <span className="c1">
              &nbsp;Of course, taking on extra debt won&#39;t provide a
              long-term solution if you recently lost your job or had another
              financial misfortune. But if you&#39;re asking for a raise
              nevertheless, leave out the details of the missed workdays,
              medical expenses, increased debt, higher mortgage payments, etc.
              In addition to virtually preventing you from gaining an increase,
              voluntarily providing your issuer with this &quot;red flag&quot;
              information might result in their lowering your limit.
            </span>
          </p>
          <p className="c0">
            <span className="c1">
              If your credit card account is in excellent standing, now is a
              good time to request an increase in your credit limit. With the
              2008 financial crisis, issuers became extremely conservative with
              credit, reducing limits or canceling accounts outright to reduce
              their risk exposure. Today, these businesses are more optimistic
              about the economy and more prepared to take risks; they are
              putting out more offers, and some are even considering candidates
              with weaker credit scores. If you utilize a smaller fraction of
              your credit limit, a larger credit limit can actually improve your
              credit score, therefore a greater limit is a useful tool if used
              properly. Find out what you should and should not say to earn more
              credit.
            </span>
          </p>
          <p className="c0">
            <span className="c1">
              According to Natalie Lohrenz, director of counseling at the
              Consumer Credit Counseling Service in Orange County, California,
              your chances of obtaining a higher limit are greater if you have
              excellent credit. She states, &quot;It&#39;s probably not going to
              happen if your credit is only good or medium.&quot; But if you
              have an A+ score and wish to obtain more credit, here are some
              suggestions:
            </span>
          </p>
          <p className="c0">
            <span className="c1">
              Explain why you desire the raise. If you want to begin charging
              more, such as paying your monthly smartphone bill or booking
              business travel, inform the representative when you call. Suppose
              you wish to maintain a credit usage percentage below 30%, but
              would like to use your card more. If the card offers benefits, so
              much the better. You can explain, &quot;I&#39;d want to take use
              of your fantastic rewards program more, but I&#39;m worried that
              my usage ratio is becoming too high. Can you raise my limit?&quot;
            </span>
          </p>
          <p className="c0">
            <span className="c1">
              Do not be frightened to defend your position. Lohrenz suggests
              that you justify your request for a greater credit limit. Indicate
              if your credit score has improved since you opened the card.
              &quot;You should also indicate if your financial resources have
              increased since opening the account,&quot; she explains. Inform
              the issuer if you received a promotion, settlement, second
              employment, or other increase in income. Also, let them know if
              you recently paid off a large debt (such as college tuition or a
              home). This indicates to the issuer that your discretionary income
              has grown.
            </span>
          </p>
          <p className="c0">
            <span className="c1">
              Motivate your issuer to become competitive. With a good credit
              score, you likely receive numerous direct mail solicitations. Use
              unwanted mail to your advantage. &quot;Creditors are aware that
              you can easily seek an increase elsewhere, so utilize this to your
              advantage,&quot; Lohrenz advises. &quot;Tell them you are
              considering transferring your balance to another card but would
              rather stay with them if they would simply boost your credit limit
              &mdash; they don&#39;t want to lose a good customer.&quot;
            </span>
          </p>
          <p className="c0">
            <span className="c1">
            <span className="c2 fw-bold">5. Keep your story of woe to yourself. </span>
              Obviously, if you have lost your job or experienced another financial setback, taking on
              additional debt will not address your difficulties in the long
              run. But if you&#39;re seeking a raise nevertheless, omit the
              information about your lost work hours, hospital cost, or rising
              ARM payment. Not only will this virtually certainly prevent you
              from receiving a credit limit increase, but voluntarily providing
              this &quot;red flag&quot; information to your credit card provider
              may drive them to reduce your credit limit.
            </span>
          </p>
          <p className="c0 c3">
            <span className="c1"></span>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default IncreaseLimitModal;
